import API from '../../sunwiseAPI';
const ENTITY = 'template-reporter';

export const updateTemplate = (reportId, templateId) =>
    API.put(`/api/v1/${ENTITY}/${reportId}/sunpay`, {
        external_custom_template_id: templateId,
    });
